import { INBOX, KB } from './productTypes'
import {
  USAGE_INBOX_API_ACCESS,
  USAGE_INBOX_BRANDING,
  USAGE_INBOX_CANNED_REPLIES,
  USAGE_INBOX_CHANNELS,
  USAGE_INBOX_CUSTOM_FIELDS,
  USAGE_INBOX_CUSTOM_PROFILE,
  USAGE_INBOX_FOLDERS,
  USAGE_INBOX_INTEGRATIONS,
  USAGE_INBOX_MAILBOXES,
  USAGE_INBOX_PREMIUM_INTEGRATIONS,
  USAGE_INBOX_RULES,
  USAGE_INBOX_RULES_TIER_1,
  USAGE_INBOX_RULES_TIER_2,
  USAGE_INBOX_SATISFACTIONS_RATINGS,
  USAGE_INBOX_TEAMS,
  USAGE_INBOX_USERS,
  USAGE_INBOX_WEBHOOKS,
  USAGE_INBOX_WIDGETS,
  USAGE_KB_ARTICLES,
  USAGE_KB_BRANDING,
  USAGE_KB_CUSTOM_SCRIPTS,
  USAGE_KB_KBS,
  USAGE_KB_PRIVATE,
  USAGE_KB_SEO,
} from './usageTypes'

export const FEATURE_INBOX_MAX_CHANNELS = 'max_channels'
export const FEATURE_INBOX_MAX_MAILBOXES = 'max_mailboxes'
export const FEATURE_INBOX_MAX_INTEGRATIONS = 'max_integrations'
export const FEATURE_INBOX_MAX_REPORTING_DAYS = 'max_reporting_days'
export const FEATURE_INBOX_REPORTS = 'reports'
export const FEATURE_INBOX_MAX_CONVERSATIONS = 'max_conversations'
export const FEATURE_INBOX_MAX_SEARCH_HISTORY_DAYS = 'max_search_history_days'
export const FEATURE_INBOX_MAX_USERS = 'max_users'
export const FEATURE_INBOX_TEAMS = 'teams'
export const FEATURE_INBOX_API_ACCESS = 'api_access'
export const FEATURE_INBOX_SATISFACTIONS_RATINGS = 'satisfactions_ratings'
export const FEATURE_INBOX_FOLDERS_CUSTOM = 'folders_custom'
export const FEATURE_INBOX_MAX_FOLDERS = 'max_folders'
export const FEATURE_INBOX_RULES = 'rules'
export const FEATURE_INBOX_MAX_RULES = 'max_rules'
export const FEATURE_INBOX_RULES_TIER_1 = 'rules_tier_1'
export const FEATURE_INBOX_RULES_TIER_2 = 'rules_tier_2'
export const FEATURE_INBOX_WORKFLOWS = 'workflows'
export const FEATURE_INBOX_EXPORTS = 'exports'
export const FEATURE_INBOX_WEBHOOKS = 'webhooks'
export const FEATURE_INBOX_CUSTOM_FIELDS = 'custom_fields'
export const FEATURE_INBOX_CUSTOM_PROFILE = 'custom_profile'
export const FEATURE_INBOX_MENTIONS = 'mentions'
export const FEATURE_INBOX_COMMENTS = 'comments'
export const FEATURE_INBOX_MAX_CANNED_REPLIES = 'max_canned_replies'
export const FEATURE_INBOX_CANNED_REPLIES_TIER_1 = 'canned_replies_tier_1'
export const FEATURE_INBOX_MAX_WIDGETS = 'max_widgets'
export const FEATURE_INBOX_LIVE_CHAT = 'live_chat'
export const FEATURE_INBOX_PREMIUM_INTEGRATIONS = 'premium_integrations'
export const FEATURE_INBOX_SSO_SAML = 'sso_saml'
export const FEATURE_INBOX_2FA = '2fa'
export const FEATURE_INBOX_DEDICATED_SUCCESS = 'dedicated_success'
export const FEATURE_INBOX_PRIORITY_SUPPORT = 'priority_support'
export const FEATURE_INBOX_BRANDING = 'branding'
export const FEATURE_ROUND_ROBIN = 'round_robin'

// KB
export const FEATURE_KB_MAX_KBS = 'max_kbs'
export const FEATURE_KB_MAX_ARTICLES = 'max_articles'
export const FEATURE_KB_BRANDING = 'branding'
export const FEATURE_KB_MAX_REPORTING_DAYS = 'max_reporting_days'
export const FEATURE_KB_REPORTS = 'reports'
export const FEATURE_KB_CUSTOM_SCRIPTS = 'custom_scripts'
export const FEATURE_KB_PRIVATE = 'private'
export const FEATURE_KB_SEO = 'seo'

// we have this because the feature names to not match 1:1 with billing usage keys
// if value is null, means it's not usage based
const INBOX_FEATURE_TO_BILLING_USAGE_TYPE = new Map([
  [FEATURE_INBOX_MAX_CHANNELS, USAGE_INBOX_CHANNELS],
  [FEATURE_INBOX_MAX_MAILBOXES, USAGE_INBOX_MAILBOXES],
  [FEATURE_INBOX_MAX_INTEGRATIONS, USAGE_INBOX_INTEGRATIONS],
  [FEATURE_INBOX_MAX_REPORTING_DAYS, null],
  [FEATURE_INBOX_REPORTS, null],
  [FEATURE_INBOX_MAX_CONVERSATIONS, null],
  [FEATURE_INBOX_MAX_SEARCH_HISTORY_DAYS, null],
  [FEATURE_INBOX_MAX_USERS, USAGE_INBOX_USERS],
  [FEATURE_INBOX_TEAMS, USAGE_INBOX_TEAMS],
  [FEATURE_INBOX_API_ACCESS, USAGE_INBOX_API_ACCESS],
  [FEATURE_INBOX_SATISFACTIONS_RATINGS, USAGE_INBOX_SATISFACTIONS_RATINGS],
  [FEATURE_INBOX_FOLDERS_CUSTOM, null],
  [FEATURE_INBOX_MAX_FOLDERS, USAGE_INBOX_FOLDERS],
  [FEATURE_INBOX_RULES, null],
  [FEATURE_INBOX_MAX_RULES, USAGE_INBOX_RULES],
  [FEATURE_INBOX_RULES_TIER_1, USAGE_INBOX_RULES_TIER_1],
  [FEATURE_INBOX_RULES_TIER_2, USAGE_INBOX_RULES_TIER_2],
  [FEATURE_INBOX_WORKFLOWS, null],
  [FEATURE_INBOX_EXPORTS, null],
  [FEATURE_INBOX_WEBHOOKS, USAGE_INBOX_WEBHOOKS],
  [FEATURE_INBOX_CUSTOM_FIELDS, USAGE_INBOX_CUSTOM_FIELDS],
  [FEATURE_INBOX_CUSTOM_PROFILE, USAGE_INBOX_CUSTOM_PROFILE],
  [FEATURE_INBOX_MENTIONS, null],
  [FEATURE_INBOX_COMMENTS, null],
  [FEATURE_INBOX_MAX_CANNED_REPLIES, USAGE_INBOX_CANNED_REPLIES],
  [FEATURE_INBOX_MAX_WIDGETS, USAGE_INBOX_WIDGETS],
  [FEATURE_INBOX_LIVE_CHAT, null],
  [FEATURE_INBOX_PREMIUM_INTEGRATIONS, USAGE_INBOX_PREMIUM_INTEGRATIONS],
  [FEATURE_INBOX_SSO_SAML, null],
  [FEATURE_INBOX_2FA, null],
  [FEATURE_INBOX_DEDICATED_SUCCESS, null],
  [FEATURE_INBOX_PRIORITY_SUPPORT, null],
  [FEATURE_INBOX_BRANDING, USAGE_INBOX_BRANDING],
])

const KB_FEATURE_TO_BILLING_USAGE_TYPE = new Map([
  [FEATURE_KB_MAX_KBS, USAGE_KB_KBS],
  [FEATURE_KB_MAX_ARTICLES, USAGE_KB_ARTICLES],
  [FEATURE_KB_BRANDING, USAGE_KB_BRANDING],
  [FEATURE_KB_MAX_REPORTING_DAYS, null],
  [FEATURE_KB_REPORTS, null],
  [FEATURE_KB_CUSTOM_SCRIPTS, USAGE_KB_CUSTOM_SCRIPTS],
  [FEATURE_KB_PRIVATE, USAGE_KB_PRIVATE],
  [FEATURE_KB_SEO, USAGE_KB_SEO],
])

const PRODUCT_FEATURE_TO_USAGE_BILLING = new Map([
  [INBOX, INBOX_FEATURE_TO_BILLING_USAGE_TYPE],
  [KB, KB_FEATURE_TO_BILLING_USAGE_TYPE],
])

export const billingUsageKeyForProductFeature = (product, feature) => {
  return PRODUCT_FEATURE_TO_USAGE_BILLING.get(product)?.get(feature)
}
